import { Component, OnInit, AfterViewInit, ViewChildren } from "@angular/core";
import * as moment from "moment";
import { HttpClient } from "@angular/common/http";
import * as zoom from '../../../assets/js/zoom';
import { AuthService } from "app/auth/auth.service";
import { ApiService } from "app/services/api.service";
import { map } from "rxjs/operators";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: "app-timeline3d",
  templateUrl: "./timeline3d.component.html",
  styleUrls: ["./timeline3d.component.scss"]
})
export class Timeline3dComponent implements OnInit {

  @ViewChildren('elementsTimeline') elementsTimeline;
  public timelineData;
  public config;
  public safeURL: SafeResourceUrl;

  constructor(private http: HttpClient, private authService: AuthService, private _api: ApiService, private _sanitizer: DomSanitizer) {}


  splitDate(date: string, format: string) {
    return moment(new Date(date)).format(format);
  }

  showDetails(id: string) {
    const element = this.timelineData.filter(el => el.id === id)[0];
    console.log('element', element);
    if (element.type !== 'type2') {
      const section = document.getElementById(id).getElementsByTagName('section')[0];
      section.classList.add('expanded');
      const nav_item: HTMLElement =  document.getElementsByClassName('menu__item--active')[0] as HTMLElement;
      nav_item.click();
    }
  }
  hideDetails(id: string) {
    const section = document.getElementById(id).getElementsByTagName('section')[0];
    section.classList.remove('expanded');
  }

  ngOnInit() {
    this.authService.login();
    this.http.get('assets/json/timeline.json').subscribe((data: {config: any, elements: any }) => {
      this.config = data.config;
      this.timelineData = data.elements;
      this.timelineData.forEach(element => {
        if (element.links) {
          element.links.forEach(link => {
            if (link.type === 'Mosaiko') {
              console.log('link id', link.id);
              this._api.returnScheda('UA', link.id).pipe(map((res: any) => res.ReturnedScheda)).subscribe(response => {
                const scheda = response;
                console.log('scheda', scheda);
                link.url = 'scheda/' + link.id;
                link.title = scheda.AssignedTitle;
                link.excerpt = scheda.Content;
                link.image = scheda.Attachments[0].MediumUrl;
              });
            }
          })
        }
        if (element.videoId) {
          element.videoId = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + element.videoId);
        }
      })
      this.elementsTimeline.changes.subscribe(t => {
        window["zoom"].init();
      })
    })
  }
}
